"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
var vue_1 = require("vue");
var _withScopeId = function (n) { return (vue_1.pushScopeId("data-v-9762a604"), n = n(), vue_1.popScopeId(), n); };
var _hoisted_1 = {
    key: 0,
    class: "chat-default"
};
var _hoisted_2 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_1.createElementVNode("img", {
    class: "chat-default-img",
    src: "https://image.iguopin.com/public/no-message.png"
}, null, -1); });
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_1.createElementVNode("div", { class: "chat-default-text" }, "暂时没有新消息", -1); });
function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_el_button = vue_1.resolveComponent("el-button");
    var _component_LiteItem = vue_1.resolveComponent("LiteItem");
    return (vue_1.openBlock(), vue_1.createElementBlock("ul", {
        class: vue_1.normalizeClass(["TUI-conversation-list", [_ctx.isH5 ? 'list-h5' : '']]),
        ref: "list",
        onMousewheel: _cache[0] || (_cache[0] =
            //@ts-ignore
            function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return (_ctx.scrollChange && _ctx.scrollChange.apply(_ctx, args));
            }),
        onScroll: _cache[1] || (_cache[1] =
            //@ts-ignore
            function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return (_ctx.scrollChange && _ctx.scrollChange.apply(_ctx, args));
            })
    }, [
        (_ctx.isH5 && !_ctx.loading && _ctx.data.list.length === 0)
            ? (vue_1.openBlock(), vue_1.createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _hoisted_3,
                vue_1.createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _ctx.toHome
                }, {
                    default: vue_1.withCtx(function () { return [
                        vue_1.createTextVNode("返回国聘首页")
                    ]; }),
                    _: 1
                }, 8, ["onClick"])
            ]))
            : vue_1.createCommentVNode("", true),
        (vue_1.openBlock(true), vue_1.createElementBlock(vue_1.Fragment, null, vue_1.renderList(_ctx.data.list, function (item, index) {
            return (vue_1.openBlock(), vue_1.createBlock(_component_LiteItem, {
                isH5: _ctx.isH5,
                key: index,
                currentID: _ctx.currentID,
                conversation: item,
                toggleID: _ctx.toggleID,
                handleConversation: {
                    avator: _ctx.data.handleItemAvator,
                    name: _ctx.data.handleItemName,
                    showAt: _ctx.data.handleShowAt,
                    showMessage: _ctx.data.handleShowMessage,
                    time: _ctx.data.handleItemTime,
                    userID: _ctx.data.handleItemUserID,
                    selfSignature: _ctx.data.handleItemSelfSignature,
                },
                displayOnlineStatus: _ctx.displayOnlineStatus,
                userStatusList: _ctx.userStatusList,
                onToggle: _ctx.handleToggleListItem,
                onOpen: _ctx.handleListItem,
                onHandle: _ctx.handleItem,
                types: _ctx.types
            }, null, 8, ["isH5", "currentID", "conversation", "toggleID", "handleConversation", "displayOnlineStatus", "userStatusList", "onToggle", "onOpen", "onHandle", "types"]));
        }), 128))
    ], 34));
}
exports.render = render;
